import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { LOGIN_STATUS, authSelectors } from '@rosetta/react-auth';
import { questionnaireActions, questionnaireSelectors } from '../reducer/questionnaire-reducer';
import { getQuestionnaireData, questionnairelionMapping } from '../services/questionnaire-helpers';
import { lionSelectors } from '@rosetta/react-lion';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { appActions, appSelectors, LOG_LEVEL } from '../../app/reducer/app-reducer';
import { RSDropdown } from '@rosetta/rs-dropdown';
import { menuStyle } from '../../../styles/LaunchpadDropdownStyle';
import { getTargetLanguageCode } from '../../app/util/user-helper';

import {
  appMainBackground,
  appTextColor,
  blueHoverColor,
  darkRed,
  lightBlueColor,
  progressBarBackground,
  progressBarForeground,
  dashboardGoalsBackground,
  lighterGrey,
  white
} from '../../../styles/colors';

import { withWindowDimensions } from '@rosetta/react-common-ui';
import { isMobile as isMobileDetected } from 'react-device-detect';

let progressBarWidth;
let haveShownFirstQuestion;

let SliderHandleStyle = {
  borderColor: white,
  borderWidth: '4px',
  height: 24,
  width: 24,
  marginLeft: -12,
  marginTop: -10,
  backgroundColor: lightBlueColor,
  boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.3)'
};

let SliderDotStyle = {
  borderColor: appMainBackground,
  height: 14,
  width: 14,
  background: appMainBackground,
  marginBottom: -3
};
let SliderActiveDotStyle = {
  background: lightBlueColor,
  marginLeft: -7,
  borderWidth: 0
};

let SliderRailStyle = {
  backgroundColor: appMainBackground,
  height: 3
};

let SliderTrackStyle = {
  background: lightBlueColor,
  height: 3
};

const QuestionsAnswersContainer = styled.div((props) => {
  let style = {
    background: !props.isMobile ? white : appMainBackground,
    cursor: 'default',
    margin: !props.isMobile ? '30px auto 0' : '20px 16px 0',
    position: 'relative',
    textAlign: 'left',
    width: !props.isMobile ? '1000px' : 'auto',
    boxShadow: !props.isMobile ? '2px 2px 6px 0 rgba(0, 0, 0, 0.07)' : 'none',
    borderRadius: '4px'
  };
  return style;
});

const QuestionsAnswersWrapper = styled.div((props) => {
  let style = {
    boxSizing: 'border-box',
    color: appTextColor,
    cursor: 'default',
    display: 'block',
    fontSize: '16px',
    lineHeight: '18px',
    padding: !props.isMobile ? '0 100px 75px' : '0',
    textAlign: 'left',
    userSelect: 'none'
  };
  return style;
});

const ProgressAreaWrapper = styled.div({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  lineHeight: '12px'
});

const ProgressBar = styled.div({
  backgroundColor: progressBarBackground,
  height: '8px',
  marginBottom: '0',
  marginTop: '1px',
  width: '100%'
});

const ProgressBarFill = styled.div(() => {
  let styling = {
    backgroundColor: progressBarForeground,
    float: 'left',
    height: '8px',
    transition: 'width .6s ease'
  };
  if (progressBarWidth) {
    styling.width = '' + progressBarWidth + '%';
  } else {
    styling.width = haveShownFirstQuestion ? '0%' : '5%';
  }
  return styling;
});

const MessageArea = styled.div({
  color: darkRed,
  cursor: 'default',
  margin: '10px auto 0',
  position: 'relative'
});

const QuestionAndAnswersBox = styled.div({
  bottom: '0',
  cursor: 'default',
  fontFamily: 'NotoSans, NotoSans_Hebrew, NotoSans_Arabic, NotoSans_Hindi, NotoSans_JP, NotoSans_KR, NotoSans_TC, NotoSans_SC',
  fontSize: '16px',
  left: '0',
  lineHeight: '18px',
  margin: '0 auto',
  position: 'relative',
  right: '0',
  top: '0'
});

const PostQuestionArea = styled.div({
  fontSize: '16px',
  paddingBottom: '30px',
  fontWeight: 200
});

const QuestionArea = styled.div({
  fontSize: '22px',
  lineHeight: '30px',
  margin: '11px 0 20px'
});

const AnswersArea = styled.div({
  bottom: '0',
  cursor: 'default',
  left: '0',
  lineHeight: '18px',
  margin: '0 auto',
  position: 'relative',
  right: '0',
  top: '0'
});

const SliderAnswerArea = styled.div({
  marginBottom: '50px'
});

const AnswersMultipleRadioLists = styled.div({
  fontSize: '16px'
});

const StripedQuestionRow = styled.div({});

const HeaderCell = styled.div((props) => {
  let style = {};
  if (props.isMobile) {
    style.display = 'inline-flex';
    style.paddingLeft = '10px';
  }
  return style;
});

const SubQuestionTitleCell = styled.div((props) => {
  let style = {
    fontSize: '16px'
  };
  if (props.isMobile) {
    style.marginBottom = '10px';
  }
  return style;
});

const AnswerCell = styled.div((props) => {
  let style = {
    textAlign: !props.isMobile ? 'center' : 'left',
    width: !props.isMobile ? '16%' : '100%',
    fontSize: '12px',
    display: !props.isMobile ? 'inline-block' : 'block',
    verticalAlign: 'top',
    margin: !props.isMobile ? '30px 0 50px' : '',
    position: 'relative'
  };
  if (props.isMobile) {
    style.backgroundColor = white;
    style.borderRadius = '4px';
    style.padding = '10px';
    style.marginBottom = '10px';
  }
  return style;
});

const AnswersOtherText = styled.textarea({
  fontFamily: 'NotoSans, NotoSans_Hebrew, NotoSans_Arabic, NotoSans_Hindi, NotoSans_JP, NotoSans_KR, NotoSans_TC, NotoSans_SC',
  fontSize: '16px',
  fontStretch: '100%',
  fontWeight: '400',
  padding: '8px',
  width: '100%',
  height: '84px'
});

const AnswersListItem = styled.label((props) => {
  let style = {
    fontSize: '14px',
    fontWeight: '400',
    display: !props.isMobile ? 'block' : 'flex',
    marginBottom: !props.isMobile ? '20px' : '10px',
    position: 'relative'
  };
  if (props.isMobile) {
    style.backgroundColor = white;
    style.borderRadius = '4px';
    style.padding = '10px';
    style.minHeight = '84px';
    style.width = '100%';
    style.alignItems = 'center';
  }
  return style;
});

const AnswerLabel = styled.span({
  ':hover': {
    cursor: 'pointer'
  },
  paddingLeft: '6px'
});

const RankedAnswersListItem = styled.label((props) => {
  let style = {
    fontSize: '14px',
    fontWeight: '400',
    display: 'block',
    marginBottom: !props.isMobile ? '20px' : '10px',
    position: 'relative'
  };

  return style;
});

const RankedAnswerLabel = styled.div({
  fontWeight: '500',
  fontSize: '15px',
  marginBottom: '10px'
});

const MenuContainer = styled.div((props) => {
  let style = {
    display: 'block',
    height: '38px',
    width: !props.isMobile ? '300px' : '100%',
    marginBottom: '15px'
  };
  return style;
});

const NavArea = styled.div((props) => {
  let style = {
    display: 'block',
    padding: !props.isMobile ? '20px 0' : '16px',
    width: !props.isMobile ? '1000px' : 'auto',
    margin: 'auto',
    textAlign: 'right'
  };
  return style;
});

const BackButton = styled.div({
  backgroundColor: appMainBackground,
  border: '2px solid ' + lightBlueColor,
  borderRadius: '4px',
  color: lightBlueColor,
  cursor: 'pointer',
  display: 'inline-block',
  fontSize: '14px',
  fontWeight: '400',
  height: '37px',
  letterSpacing: '1px',
  lineHeight: '36px',
  margin: '0 10px',
  padding: '0 40px',
  textAlign: 'center',
  width: 'auto',
  ':hover': {
    backgroundColor: blueHoverColor,
    color: white
  }
});

const NextButton = styled.div({
  backgroundColor: lightBlueColor,
  border: '2px solid ' + lightBlueColor,
  borderRadius: '4px',
  color: white,
  cursor: 'pointer',
  display: 'inline-block',
  fontWeight: '400',
  fontSize: '14px',
  height: '36px',
  ':hover': {
    backgroundColor: blueHoverColor
  },
  letterSpacing: '1px',
  lineHeight: '38px',
  margin: '0 0 0 10px',
  padding: '0 40px',
  textAlign: 'center',
  width: 'auto'
});

const AnswerInput = styled.input({
  ':hover': {
    cursor: 'pointer'
  }
});

const AnswerRadioOverlay = styled.div((props) => {
  let style = {
    display: 'inline-flex',
    position: 'relative',
    border: '2px solid ',
    borderColor: !props.selected ? lighterGrey : lightBlueColor,
    borderRadius: '100%',
    height: '16px',
    width: '16px',
    minWidth: '16px',
    zIndex: '5',

    '::before': {
      display: 'block',
      position: 'absolute',
      content: '""',
      borderRadius: '100%',
      height: '10px',
      width: '10px',
      top: '1px',
      left: '1px',
      margin: 'auto',
      backgroundColor: props.selected ? lightBlueColor : white
    }
  };
  return style;
});

const AnswerRadioLabel = styled.span({
  display: 'inline-block',
  position: 'relative',
  padding: '0 0 0 12px',
  maxWidth: '775px',

  ':hover': {
    cursor: 'pointer'
  }
});

const AnswerRadio = styled.input({
  position: 'absolute',
  visibility: 'hidden',
  ':hover': {
    cursor: 'pointer'
  }
});

const ObjectivesLabel = styled.div((props) => {
  let style = {
    padding: !props.isMobile ? '22px 0 0 100px' : '0',
    fontSize: '16px',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    color: dashboardGoalsBackground
  };
  return style;
});

export class QuestionsAndAnswers extends Component {
  constructor(props) {
    super(props);
    haveShownFirstQuestion = false;
    props.getLearnerConfigs();
    this.getQuestionData(this.props.skipPlacementTest);

    this.state = {
      howQuestionAnswered: {},
      howFollowOnQuestionAnswered: {},
      showFollowOn: false,
      showOtherTextarea: false,
      otherTextareaContent: '',
      showRequiredMessage: false,
      skipPlacementTest: this.props.skipPlacementTest
    };
  }

  componentDidMount = () => {
    this.props.setLogoutValidation(
      true,
      this.props.getLionTranslatedString('quest_lose_changes'),
      this.props.getLionTranslatedString('quest_lose_changes_desc')
    );
  };

  componentWillUnmount = () => {
    this.props.setLogoutValidation(false, '', '');
  };

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.isAppInitialized && nextProps.loginStatus !== LOGIN_STATUS.LOGGED_IN) {
      nextProps.history.push('/login');
    }
    return null;
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.skipPlacementTest !== this.props.skipPlacementTest) {
      this.getQuestionData(this.props.skipPlacementTest);
    }
  }

  getQuestionData = (orgAllowSkipPlacementTest) => {
    const learningLanguageCode = getTargetLanguageCode(this.props.userInfo);
    const cefrNotOverriddenByAdmin =
      this.props.userInfo &&
      this.props.userInfo.targetLanguage &&
      this.props.userInfo.targetLanguage.howChosen !== 'admin';
    const showSkipPlacementTest = cefrNotOverriddenByAdmin && orgAllowSkipPlacementTest;

    this.questionnaireData = getQuestionnaireData(
      learningLanguageCode,
      this.props.productRights,
      showSkipPlacementTest
    );
  };

  answerSelected = (inputKind, currentAnswer, isFollowOnInput, optionalKey) => {
    let localHowQuestionAnswered;
    if (isFollowOnInput) {
      localHowQuestionAnswered = this.state.howFollowOnQuestionAnswered;
    } else {
      localHowQuestionAnswered = this.state.howQuestionAnswered;
    }

    if (inputKind === 'radio' && !optionalKey) {
      localHowQuestionAnswered = currentAnswer;
    } else if (inputKind === 'radio' && optionalKey) {
      localHowQuestionAnswered[optionalKey] = currentAnswer;
    } else if (inputKind === 'checkbox' && !localHowQuestionAnswered[currentAnswer]) {
      localHowQuestionAnswered[currentAnswer] = true;
    } else if (inputKind === 'checkbox' && localHowQuestionAnswered[currentAnswer]) {
      delete localHowQuestionAnswered[currentAnswer];
    }

    const currentQuestionAnswers = this.questionnaireData[this.props.currentQuestionNumber];
    const showFollowOnQuestion =
      typeof currentQuestionAnswers.show_follow_on === 'function' &&
      currentQuestionAnswers.show_follow_on(localHowQuestionAnswered);

    if (currentAnswer === 'other_please_specify' || currentAnswer === 'other_explain_below') {
      let toggledShow = !this.state.showOtherTextarea;
      this.setState({
        showOtherTextarea: toggledShow
      });
    }

    if (isFollowOnInput) {
      this.setState({
        howFollowOnQuestionAnswered: localHowQuestionAnswered
      });
    } else {
      this.setState({
        howQuestionAnswered: localHowQuestionAnswered,
        showFollowOn: showFollowOnQuestion
      });
    }
  };

  enterOtherText = (questionText, newAnswerTextEvent, isFollowOnInput) => {
    let localHowQuestionAnswered;
    if (isFollowOnInput) {
      localHowQuestionAnswered = this.state.howFollowOnQuestionAnswered;
    } else {
      localHowQuestionAnswered = this.state.howQuestionAnswered;
    }

    this.setState({
      otherTextareaContent: newAnswerTextEvent.target.value
    });

    const otherKey = questionText + '_other';
    localHowQuestionAnswered[otherKey] = newAnswerTextEvent.target.value;

    if (isFollowOnInput) {
      this.setState({ howFollowOnQuestionAnswered: localHowQuestionAnswered });
    } else {
      this.setState({ howQuestionAnswered: localHowQuestionAnswered });
    }
  };

  handleSliderChange = (value, isFollowOnInput) => {
    if (isFollowOnInput) {
      this.setState({ howFollowOnQuestionAnswered: value });
    } else {
      this.setState({ howQuestionAnswered: value });
    }
  };

  handleScoreSelected = (scoreObj) => {
    this.setState({ howQuestionAnswered: scoreObj.value });
  };

  handleFollowScoreSelected = (scoreObj) => {
    this.setState({ howFollowOnQuestionAnswered: scoreObj.value });
  };

  handleSurveySelected = (surveyObj) => {
    this.answerSelected('radio', surveyObj.value, false, surveyObj.key);
  };

  handleRankUpdate = (obj) => {
    let value = obj.value;
    let whichKey = obj.whichKey;
    let localRanks = this.state.currentRanks;

    if (value === ' ') {
      localRanks[whichKey] = '';
    } else {
      const enteredNumber = parseInt(value, 10);

      // Get rid of this value if it appears on another key
      for (const key in localRanks) {
        if (localRanks[key] === enteredNumber) {
          localRanks[key] = '';
        }
      }
      localRanks[whichKey] = enteredNumber;
    }
    this.setState({ currentRanks: localRanks });
  };

  loadCurrentAnswersFromStore = (questionNumber) => {
    const currentQuestionAnswers = this.questionnaireData[questionNumber];
    const question = currentQuestionAnswers.text;
    const followOnQuestion = currentQuestionAnswers.follow_on_text;
    const existingAnswers = this.props.getChosenAnswers;
    if (currentQuestionAnswers.ranked) {
      let ranks = existingAnswers[question];
      if (!ranks) {
        ranks = {};
        currentQuestionAnswers.answers.forEach((answer) => {
          ranks[answer] = '';
        });
      }
      this.setState({
        currentRanks: ranks,
        showRequiredMessage: false
      });
    } else {
      const existingBaseQuestionAnswers = existingAnswers[question] ? existingAnswers[question] : {};
      const existingFollowOnQuestionAnswers = existingAnswers[followOnQuestion]
        ? existingAnswers[followOnQuestion]
        : {};
      const showFollowOn =
        typeof currentQuestionAnswers.show_follow_on === 'function' &&
        currentQuestionAnswers.show_follow_on(existingBaseQuestionAnswers);
      let otherContent = '';
      let showOtherContent = false;
      if (
        existingBaseQuestionAnswers['other_please_specify'] ||
        existingBaseQuestionAnswers['other_explain_below'] ||
        existingFollowOnQuestionAnswers['other_please_specify'] ||
        existingFollowOnQuestionAnswers['other_explain_below']
      ) {
        showOtherContent = true;
        if (existingBaseQuestionAnswers[question + '_other']) {
          otherContent = existingBaseQuestionAnswers[question + '_other'];
        } else if (existingFollowOnQuestionAnswers[followOnQuestion + '_other']) {
          otherContent = existingFollowOnQuestionAnswers[followOnQuestion + '_other'];
        }
      }
      this.setState({
        howQuestionAnswered: existingBaseQuestionAnswers,
        howFollowOnQuestionAnswered: existingFollowOnQuestionAnswers,
        showFollowOn: showFollowOn,
        showOtherTextarea: showOtherContent,
        otherTextareaContent: otherContent,
        showRequiredMessage: false
      });
    }
  };

  handleNavBack = () => {
    // Save current answers
    const currentQuestionAnswers = this.questionnaireData[this.props.currentQuestionNumber];
    if (currentQuestionAnswers.ranked) {
      this.props.storeChosenAnswers(currentQuestionAnswers.text, this.state.currentRanks, null, null);
    } else {
      this.props.storeChosenAnswers(
        this.questionnaireData[this.props.currentQuestionNumber].text,
        this.state.howQuestionAnswered,
        this.questionnaireData[this.props.currentQuestionNumber].follow_on_text,
        this.state.howFollowOnQuestionAnswered
      );
    }

    // Set new previous question number
    const previousQuestionNumber = this.props.currentQuestionNumber - 1;
    if (previousQuestionNumber < 0) {
      this.props.logEvent({ level: LOG_LEVEL.ERROR, message: 'should not have previous button on first question' });
    } else {
      // Set page to previously chosen answers
      this.loadCurrentAnswersFromStore(previousQuestionNumber);
      this.props.previousQuestionNumber();
    }
  };

  endOfQuestionnaire = () => this.props.currentQuestionNumber + 1 === this.questionnaireData.length;

  handleNavForward = () => {
    // Validate required question
    const currentQuestionAnswers = this.questionnaireData[this.props.currentQuestionNumber];
    if (currentQuestionAnswers.required && Object.getOwnPropertyNames(this.state.howQuestionAnswered).length === 0) {
      this.setState({
        showRequiredMessage: true
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    } else {
      // Add current answers to stored current answers
      if (currentQuestionAnswers.ranked) {
        this.props.storeChosenAnswers(currentQuestionAnswers.text, this.state.currentRanks, null, null);
      } else {
        this.props.storeChosenAnswers(
          this.questionnaireData[this.props.currentQuestionNumber].text,
          this.state.howQuestionAnswered,
          this.questionnaireData[this.props.currentQuestionNumber].follow_on_text,
          this.state.howFollowOnQuestionAnswered
        );
      }

      // Set new next question number or submit to lps saga.
      if (this.endOfQuestionnaire()) {
        // Done, submit
        const answers = this.props.getChosenAnswers;
        answers.beginner = false;
        this.props.submitQuestionnaire(answers);
      } else {
        this.loadCurrentAnswersFromStore(this.props.currentQuestionNumber + 1);
        this.props.nextQuestionNumber();
      }
    }
    haveShownFirstQuestion = true;
  };

  handleSkipAssessmentForNovice = () => {
    const answers = this.props.getChosenAnswers;
    answers.beginner = true;
    this.props.submitQuestionnaire(answers);
  };

  mapLearningLanguageName = (answerWithPotentialVar, localizedLearningLanguage) => {
    let mappedDisplayText;
    const rawDisplayText = this.props.getLionTranslatedString(answerWithPotentialVar);
    if (rawDisplayText && rawDisplayText.indexOf('{learningLanguage}') >= 0) {
      mappedDisplayText = this.props.getLionTranslatedString(
        answerWithPotentialVar,
        'learningLanguage',
        localizedLearningLanguage
      );
    } else {
      mappedDisplayText = this.props.getLionTranslatedString(answerWithPotentialVar, 'L2', localizedLearningLanguage);
    }
    return mappedDisplayText;
  };

  buildBaseAnswersArea = (currentQuestionAnswers, localizedAnswers, localizedHeadings, localizedL2Name) => {
    const isMobile = isMobileDetected ? true : false;

    return (
      <AnswersArea>
        {currentQuestionAnswers.slider && !isMobile && (
          <SliderAnswerArea>
            <Slider
              min={currentQuestionAnswers.minValue}
              max={currentQuestionAnswers.maxValue}
              defaultValue={currentQuestionAnswers.defaultValue}
              step={currentQuestionAnswers.step_size}
              included={true}
              marks={currentQuestionAnswers.marks}
              onChange={(value) => this.handleSliderChange(value, false)}
              railStyle={SliderRailStyle}
              dotStyle={SliderDotStyle}
              activeDotStyle={SliderActiveDotStyle}
              trackStyle={SliderTrackStyle}
              handleStyle={SliderHandleStyle}
            />
          </SliderAnswerArea>
        )}

        {currentQuestionAnswers.slider && isMobile && (
          <SliderAnswerArea>
            <MenuContainer isMobile={isMobile}>
              <RSDropdown
                buttonText={this.props.getLionTranslatedString('quest_choose_one')}
                itemsList={currentQuestionAnswers.sliderItems}
                itemDisplayProperty="label"
                itemKeyProperty="value"
                onSelectionHandler={this.handleScoreSelected}
                menuStyle={menuStyle}
                selectedKey={this.state.howQuestionAnswered.toString()}
              />
            </MenuContainer>
          </SliderAnswerArea>
        )}
        {currentQuestionAnswers.ranked && (
          <div>
            {// turn ranked into RSDropdown
            localizedAnswers.map((answerData, index) => (
              <div key={answerData.value}>
                <RankedAnswersListItem isMobile={isMobile} htmlFor={answerData.value}>
                  <RankedAnswerLabel>{answerData.displayText}</RankedAnswerLabel>

                  <MenuContainer isMobile={isMobile}>
                    <RSDropdown
                      buttonText={this.props.getLionTranslatedString('quest_choose_one')}
                      itemsList={[
                        {
                          label: this.props.getLionTranslatedString('quest_skills_improve_rank_1_most'),
                          value: '1',
                          whichKey: answerData.value
                        },
                        {
                          label: this.props.getLionTranslatedString('quest_skills_improve_rank_2_imp'),
                          value: '2',
                          whichKey: answerData.value
                        },
                        {
                          label: this.props.getLionTranslatedString('quest_skills_improve_rank_3_less'),
                          value: '3',
                          whichKey: answerData.value
                        },
                        {
                          label: this.props.getLionTranslatedString('quest_skills_improve_rank_4_least'),
                          value: '4',
                          whichKey: answerData.value
                        }
                      ]}
                      itemDisplayProperty="label"
                      itemKeyProperty="value"
                      onSelectionHandler={this.handleRankUpdate}
                      menuStyle={menuStyle}
                      selectedKey={this.state.currentRanks[answerData.value].toString()}
                      data-qa={
                        'RankedInput' + this.questionnaireData[this.props.currentQuestionNumber].data_qa_tags[index]
                      } // moved from input
                      id={answerData.value} // moved from input
                    />
                  </MenuContainer>
                </RankedAnswersListItem>
              </div>
            ))}
          </div>
        )}
        {currentQuestionAnswers.select && !currentQuestionAnswers.scaleHeadings && (
          <div>
            {localizedAnswers.map((answerData, index) => (
              <div key={answerData.value}>
                <AnswersListItem isMobile={isMobile} htmlFor={answerData.value}>
                  <AnswerInput
                    type="checkbox"
                    data-qa={
                      'CheckBoxInput' + this.questionnaireData[this.props.currentQuestionNumber].data_qa_tags[index]
                    }
                    value={answerData.value}
                    defaultChecked={this.state.howQuestionAnswered[answerData.value]}
                    onClick={() => this.answerSelected('checkbox', answerData.value, false)}
                    id={answerData.value}
                  />
                  <AnswerLabel>{answerData.displayText}</AnswerLabel>
                </AnswersListItem>
              </div>
            ))}
          </div>
        )}
        {!currentQuestionAnswers.select && currentQuestionAnswers.scaleHeadings && !isMobile && (
          <AnswersMultipleRadioLists>
            {localizedAnswers.map((localizedAnswer) => (
              <div key={localizedAnswer.value}>
                <SubQuestionTitleCell key={localizedAnswer.value}>{localizedAnswer.displayText}</SubQuestionTitleCell>
                <StripedQuestionRow>
                  {localizedHeadings.map((localizedHeading) => (
                    <AnswerCell
                      onClick={() => this.answerSelected('radio', localizedHeading.value, false, localizedAnswer.value)}
                      key={localizedAnswer.value + '_' + localizedHeading.value}
                    >
                      <AnswerRadio
                        type="radio"
                        name={localizedAnswer.value}
                        value={localizedHeading.value}
                        defaultChecked={
                          this.state.howQuestionAnswered[localizedAnswer.value] === localizedHeading.value
                        }
                      />
                      <AnswerRadioOverlay
                        selected={this.state.howQuestionAnswered[localizedAnswer.value] === localizedHeading.value}
                      />

                      <HeaderCell key={localizedHeading.value}>{localizedHeading.displayText}</HeaderCell>
                    </AnswerCell>
                  ))}
                </StripedQuestionRow>
              </div>
            ))}
          </AnswersMultipleRadioLists>
        )}

        {!currentQuestionAnswers.select && currentQuestionAnswers.scaleHeadings && isMobile && (
          <AnswersMultipleRadioLists>
            {localizedAnswers.map((localizedAnswer) => (
              <div key={localizedAnswer.value}>
                <SubQuestionTitleCell isMobile={isMobile} key={localizedAnswer.value}>
                  {localizedAnswer.displayText}
                </SubQuestionTitleCell>
                <StripedQuestionRow>
                  <MenuContainer isMobile={isMobile}>
                    <RSDropdown
                      buttonText={this.props.getLionTranslatedString('quest_choose_one')}
                      itemsList={[
                        {
                          value: 'not_applicable',
                          label: this.props.getLionTranslatedString('quest_employment_na'),
                          key: localizedAnswer.value
                        },
                        {
                          value: 'strongly_disagree',
                          label: this.props.getLionTranslatedString('quest_likert_statements_strongly_disagree'),
                          key: localizedAnswer.value
                        },
                        {
                          value: 'disagree',
                          label: this.props.getLionTranslatedString('quest_likert_statements_disagree'),
                          key: localizedAnswer.value
                        },
                        {
                          value: 'neither_agree_nor_disagree',
                          label: this.props.getLionTranslatedString('quest_likert_statements_neither'),
                          key: localizedAnswer.value
                        },
                        {
                          value: 'agree',
                          label: this.props.getLionTranslatedString('quest_likert_statements_agree'),
                          key: localizedAnswer.value
                        },
                        {
                          value: 'strongly_agree',
                          label: this.props.getLionTranslatedString('quest_likert_statements_strongly_agree'),
                          key: localizedAnswer.value
                        }
                      ]}
                      itemDisplayProperty="label"
                      itemKeyProperty="value"
                      onSelectionHandler={this.handleSurveySelected}
                      menuStyle={menuStyle}
                      selectedKey={this.state.howQuestionAnswered[localizedAnswer.value]}
                      id={localizedAnswer.value}
                    />
                  </MenuContainer>
                </StripedQuestionRow>
              </div>
            ))}
          </AnswersMultipleRadioLists>
        )}

        {!currentQuestionAnswers.select &&
          !currentQuestionAnswers.slider &&
          !currentQuestionAnswers.ranked &&
          !currentQuestionAnswers.scaleHeadings &&
          !currentQuestionAnswers.statement && (
            <div>
              {localizedAnswers.map((answerData, index) => (
                <div key={answerData.value}>
                  <AnswersListItem isMobile={isMobile} htmlFor={answerData.value}>
                    <AnswerRadio
                      type="radio"
                      key={currentQuestionAnswers.text + '_' + answerData.value}
                      name={currentQuestionAnswers.text}
                      value={answerData.value}
                      defaultChecked={answerData.selected}
                      onChange={() => this.answerSelected('radio', answerData.value, false)}
                      id={answerData.value}
                    />
                    <AnswerRadioOverlay selected={answerData.selected} />
                    <AnswerRadioLabel
                      data-qa={
                        'RadioInput' + this.questionnaireData[this.props.currentQuestionNumber].data_qa_tags[index]
                      }
                    >
                      {answerData.displayText}
                    </AnswerRadioLabel>
                  </AnswersListItem>
                </div>
              ))}
            </div>
          )}
        {currentQuestionAnswers.other_please_specify && this.state.showOtherTextarea && (
          <AnswersOtherText
            rows="4"
            value={this.state.otherTextareaContent}
            onChange={(event) => this.enterOtherText(currentQuestionAnswers.text, event, false)}
          />
        )}
        {currentQuestionAnswers.statement &&
          currentQuestionAnswers.answers.map((answer) => (
            <p key={answer}>
              {this.props.getLionTranslatedString(questionnairelionMapping[answer], 'L2', localizedL2Name)}
            </p>
          ))}
      </AnswersArea>
    );
  };

  buildFollowOnAnswersArea = (currentQuestionAnswers, followOnLocalizedAnswers) => {
     const isMobile = isMobileDetected ? true : false;
     return (
      <AnswersArea data-qa="FollowOnQuestions">
        {currentQuestionAnswers.follow_on_slider && !isMobile && (
          <SliderAnswerArea>
            <Slider
              min={currentQuestionAnswers.followOnMinValue}
              max={currentQuestionAnswers.followOnMaxValue}
              defaultValue={currentQuestionAnswers.followOnDefaultValue}
              step={currentQuestionAnswers.follow_on_step_size}
              included={true}
              marks={currentQuestionAnswers.followOnMarks}
              onChange={(value) => this.handleSliderChange(value, true)}
              railStyle={SliderRailStyle}
              dotStyle={SliderDotStyle}
              activeDotStyle={SliderActiveDotStyle}
              trackStyle={SliderTrackStyle}
              handleStyle={SliderHandleStyle}
            />
          </SliderAnswerArea>
        )}

        {currentQuestionAnswers.follow_on_slider && isMobile && (
          <SliderAnswerArea>
            <MenuContainer isMobile={isMobile}>
              <RSDropdown
                buttonText={this.props.getLionTranslatedString('quest_choose_one')}
                itemsList={currentQuestionAnswers.followOnSliderItems}
                itemDisplayProperty="label"
                itemKeyProperty="value"
                onSelectionHandler={this.handleFollowScoreSelected}
                menuStyle={menuStyle}
                selectedKey={this.state.howFollowOnQuestionAnswered.toString()}
              />
            </MenuContainer>
          </SliderAnswerArea>
        )}

        {currentQuestionAnswers.follow_on_select && (
          <div>
            {followOnLocalizedAnswers.map((answerData) => (
              <div key={answerData.value}>
                <AnswersListItem isMobile={isMobile} htmlFor={answerData.value}>
                  <AnswerInput
                    type="checkbox"
                    value={answerData.value}
                    defaultChecked={this.state.howFollowOnQuestionAnswered[answerData.value]}
                    onClick={() => this.answerSelected('checkbox', answerData.value, true)}
                    id={answerData.value}
                  />
                  <AnswerLabel>{answerData.displayText}</AnswerLabel>
                </AnswersListItem>
              </div>
            ))}
          </div>
        )}
        {currentQuestionAnswers.follow_on_other_please_specify && this.state.showOtherTextarea && (
          <AnswersOtherText
            rows="4"
            value={this.state.otherTextareaContent}
            onChange={(event) => this.enterOtherText(currentQuestionAnswers.follow_on_text, event, true)}
          />
        )}
      </AnswersArea>
    );
  };

  render = () => {
    const isMobile = isMobileDetected ? true : false;

    if (!this.props.lionLoaded || this.props.loginStatus !== LOGIN_STATUS.LOGGED_IN) {
      return null;
    }

    const learningLanguageCode = getTargetLanguageCode(this.props.userInfo);
    const localizedL2Name = learningLanguageCode
      ? this.props.getLionTranslatedString('quest_full_language_' + learningLanguageCode)
      : '';
    let currentQuestionAnswers = this.questionnaireData[this.props.currentQuestionNumber];
    if (currentQuestionAnswers.slider) {
      let marks = {}; // used for web slider
      let sliderItems = []; // used for mobile dropdown

      let minValue = null;
      let maxValue = null;
      currentQuestionAnswers.answers.forEach((answer) => {
        sliderItems.push({ value: answer.toString(), label: answer.toString() });
        marks[parseInt(answer, 10)] = answer;

        if (!maxValue || parseInt(answer, 10) > maxValue) {
          maxValue = parseInt(answer, 10);
        }
        if (!minValue || parseInt(answer, 10) < minValue) {
          minValue = parseInt(answer, 10);
        }
      });

      currentQuestionAnswers.marks = marks;
      currentQuestionAnswers.sliderItems = sliderItems;

      currentQuestionAnswers.minValue = minValue;
      currentQuestionAnswers.maxValue = maxValue;
      if (isNaN(this.state.howQuestionAnswered)) {
        currentQuestionAnswers.defaultValue = minValue;
      } else {
        currentQuestionAnswers.defaultValue = this.state.howQuestionAnswered;
      }
      if (currentQuestionAnswers.show_follow_on(null)) {
        let followOnMarks = {}; // used for web slider
        let followOnSliderItems = []; // used for mobile dropdown

        minValue = null;
        maxValue = null;
        currentQuestionAnswers.follow_on_answers.forEach((answer) => {
          followOnSliderItems.push({ value: answer.toString(), label: answer.toString() });
          followOnMarks[parseInt(answer, 10)] = answer;
          if (!maxValue || parseInt(answer, 10) > maxValue) {
            maxValue = parseInt(answer, 10);
          }
          if (!minValue || parseInt(answer, 10) < minValue) {
            minValue = parseInt(answer, 10);
          }
        });
        currentQuestionAnswers.followOnMarks = followOnMarks;
        currentQuestionAnswers.followOnSliderItems = followOnSliderItems;
        currentQuestionAnswers.followOnMinValue = minValue;
        currentQuestionAnswers.followOnMaxValue = maxValue;
        if (isNaN(this.state.howFollowOnQuestionAnswered)) {
          currentQuestionAnswers.followOnDefaultValue = minValue;
        } else {
          currentQuestionAnswers.followOnDefaultValue = this.state.howFollowOnQuestionAnswered;
        }
      }
    }
    let localizedQuestion = this.props.getLionTranslatedString(
      questionnairelionMapping[currentQuestionAnswers.text],
      'L2',
      localizedL2Name
    );

    let localizedPostQuestion;
    if (currentQuestionAnswers.post_text) {
      localizedPostQuestion = this.props.getLionTranslatedString(
        questionnairelionMapping[currentQuestionAnswers.post_text],
        'learningLanguage',
        localizedL2Name
      );
    }

    let localizedAnswers = currentQuestionAnswers.answers.map((answer) => {
      let selectFlag;
      if (currentQuestionAnswers.select) {
        selectFlag = this.state.howQuestionAnswered[answer] ? true : false;
      } else {
        selectFlag = this.state.howQuestionAnswered === answer;
      }
      return {
        value: answer,
        selected: selectFlag,
        displayText: this.mapLearningLanguageName(questionnairelionMapping[answer], localizedL2Name)
      };
    });
    let followOnLocalizedQuestion = currentQuestionAnswers.follow_on_text
      ? this.props.getLionTranslatedString(
          questionnairelionMapping[currentQuestionAnswers.follow_on_text],
          'L2',
          localizedL2Name
        )
      : '';
    let followOnLocalizedAnswers = currentQuestionAnswers.follow_on_text
      ? currentQuestionAnswers.follow_on_answers.map((answer) => {
          return {
            value: answer,
            selected: this.state.howFollowOnQuestionAnswered[answer],
            displayText: this.mapLearningLanguageName(questionnairelionMapping[answer], localizedL2Name)
          };
        })
      : {};
    const localizedHeadings = currentQuestionAnswers.scaleHeadings
      ? currentQuestionAnswers.scaleHeadings.map((heading) => {
          return {
            value: heading,
            displayText: this.props.getLionTranslatedString(questionnairelionMapping[heading], 'L2', localizedL2Name)
          };
        })
      : [];
    const localizedRequiredMessage = this.props.getLionTranslatedString('quest_required_error');
    progressBarWidth = (this.props.currentQuestionNumber / (this.questionnaireData.length - 1)) * 100;

    return (
      <div>
        <ProgressAreaWrapper>
          <ProgressBar data-qa="ProgressBar">
            <ProgressBarFill />
          </ProgressBar>
        </ProgressAreaWrapper>
        <QuestionsAnswersContainer isMobile={isMobile}>
          <ObjectivesLabel isMobile={isMobile}>
            {this.props.getLionTranslatedString('quest_objectives_header')}
          </ObjectivesLabel>
          <QuestionsAnswersWrapper isMobile={isMobile}>
            {this.state.showRequiredMessage && <MessageArea>{localizedRequiredMessage}</MessageArea>}
            <QuestionAndAnswersBox>
              <QuestionArea>{localizedQuestion}</QuestionArea>
              {currentQuestionAnswers.post_text && <PostQuestionArea>{localizedPostQuestion}</PostQuestionArea>}
              {this.buildBaseAnswersArea(currentQuestionAnswers, localizedAnswers, localizedHeadings, localizedL2Name)}
            </QuestionAndAnswersBox>
            {this.state.showFollowOn && (
              <QuestionAndAnswersBox>
                <PostQuestionArea>{followOnLocalizedQuestion}</PostQuestionArea>
                {this.buildFollowOnAnswersArea(currentQuestionAnswers, followOnLocalizedAnswers)}
              </QuestionAndAnswersBox>
            )}
          </QuestionsAnswersWrapper>
        </QuestionsAnswersContainer>
        <NavArea isMobile={isMobile}>
          {this.props.currentQuestionNumber > 0 && (
            <BackButton
              onClick={() =>
                currentQuestionAnswers.skipAssessmentForNovice
                  ? this.handleSkipAssessmentForNovice()
                  : this.handleNavBack()
              }
            >
              {this.props.getLionTranslatedString(
                currentQuestionAnswers.alternatePreviousButtonLabel
                  ? currentQuestionAnswers.alternatePreviousButtonLabel
                  : 'back'
              )}
            </BackButton>
          )}
          <NextButton data-qa="NextButton" onClick={() => this.handleNavForward()}>
            {this.props.getLionTranslatedString(
              currentQuestionAnswers.alternateNextButtonLabel
                ? currentQuestionAnswers.alternateNextButtonLabel
                : this.endOfQuestionnaire()
                ? '_submit'
                : 'next'
            )}
          </NextButton>
        </NavArea>
      </div>
    );
  };
}

const mapStateToProps = (state, ownprops) => ({
  isAppInitialized: appSelectors.isAppInitialized(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  loginStatus: authSelectors.loginStatus(state),
  userInfo: authSelectors.userInfo(state),
  currentQuestionNumber: questionnaireSelectors.getCurrentQuestionNumber(state),
  getLionTranslatedString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  getChosenAnswers: questionnaireSelectors.getChosenAnswers(state),
  productRights: authSelectors.productRights(state),
  skipPlacementTest: questionnaireSelectors.skipPlacementTest(state)
});

const propActions = {
  nextQuestionNumber: questionnaireActions.nextQuestionNumber,
  previousQuestionNumber: questionnaireActions.previousQuestionNumber,
  storeChosenAnswers: questionnaireActions.storeChosenAnswers,
  submitQuestionnaire: questionnaireActions.submitQuestionnaire,
  setLogoutValidation: appActions.setLogoutValidation,
  logEvent: appActions.logEvent,
  getLearnerConfigs: questionnaireActions.getLearnerConfigs
};

export const QuestionsAndAnswersContainer = connect(
  mapStateToProps,
  propActions
)(withWindowDimensions(QuestionsAndAnswers));



// WEBPACK FOOTER //
// ./src/modules/questionnaire/components/QuestionsAndAnswers.jsx